// Design language F pieces for the train page: the numbered step heading and
// the dark summary card that holds each stage's main action.
import React from "react";

export const TrainStepTitle = ({ n, active = false, children, aside }) => (
  <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
    <div className="tw-flex tw-items-center tw-gap-3">
      <span
        className={`tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-font-extrabold ${
          active ? "tw-bg-jam-purple tw-text-white" : "tw-bg-jam-lav"
        }`}
      >
        {n}
      </span>
      <span className="tw-text-lg tw-font-extrabold">{children}</span>
    </div>
    {aside}
  </div>
);

export const TrainSummaryCard = ({ title, rows, children, footnote }) => (
  <aside className="tw-flex tw-flex-col tw-gap-3.5 tw-rounded-[30px] tw-bg-jam-ink tw-p-6 tw-text-white md:tw-rounded-[34px] lg:tw-sticky lg:tw-top-[calc(6rem_+_var(--card-wall-h,0px))]">
    <div className="jam-display tw-text-[26px] tw-font-extrabold tw-leading-[1.05]">
      {title}
    </div>
    <div className="tw-flex tw-flex-col tw-gap-2 tw-text-sm tw-font-bold tw-text-[#E3D3F7]">
      {rows.map(([label, value]) => (
        <div key={label} className="tw-flex tw-justify-between tw-gap-3">
          <span>{label}</span>
          <span className="tw-text-right tw-text-white">{value}</span>
        </div>
      ))}
    </div>
    {children}
    {footnote && (
      <div className="tw-text-center tw-text-xs tw-font-bold tw-text-jam-soft">
        {footnote}
      </div>
    )}
  </aside>
);

export const formatDuration = (duration) => {
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;
  let ret = "";
  if (hrs > 0) ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;
  return ret;
};

// "about 25 minutes", "about 1 hour 50 minutes" in the page's language: the
// same rounding as minutesLabel in lib/train/eta. `t` is useT()'s.
export const etaLabel = (t, min) => {
  const m = Math.round(min / 5) * 5 || 5;
  if (m < 60) return t("train.eta.minutes", { m });
  const h = Math.floor(m / 60);
  const r = m % 60;
  const key =
    h > 1
      ? r
        ? "train.eta.hoursMinutes"
        : "train.eta.hours"
      : r
        ? "train.eta.hourMinutes"
        : "train.eta.hour";
  return t(key, { h, m: r });
};

// "3 files · 6:12"
export const filesLabel = (t, n, time) =>
  n === 1 ? t("train.filesOne", { time }) : t("train.filesMany", { n, time });
